import type {ActionTree} from 'vuex'
import type {MymachineState} from './initial-state'
import {dpmmService, contentService} from '@/services'

const actions: ActionTree<MymachineState, any> = {
  fetchMachineDetails({commit, getters}) {
    const serialNumber = getters.getCurrentSerial
    const region = getters.getRegion
    if (serialNumber) {
      dpmmService.fetchDetails(serialNumber, region).then(({data}: any) => {
        if (data.serial_number === serialNumber) {
          commit('updateSerialNumber', data)
        }
      }).catch(() => {
        // silently fail
      })
    }
  },
  fetchMachine({commit}, sn: string) {
    commit('saveMachine', {
      error: null,
      loading: true,
      sn
    })
    dpmmService.fetchMachineData(sn).then((r: any) => {
      if (r.status === 200) {
        commit('saveMachine', {
          data: r.data,
          error: null,
          loading: false,
          sn
        })
      }
    }).catch((e: any) => {
      commit('saveMachine', {
        error: e,
        loading: false,
        sn
      })
    })
  },
  fetchRegionConcepts(context, region: string) {
    let _l: Record<string, any> = {}
    if (!context.state.regionConcepts[region]) {
      contentService.fetchRegionTranslations(region.toLowerCase()).then((r: any) => {
        _l = r.data
      }).catch(async () => {
        await contentService.fetchBackupTranslations(region.toLowerCase()).then((r: any) => {
          _l = r.data
        }).catch(() => {
          _l = {error: 'Error while fetching translations'}
        })
      }).finally(() => {
        context.commit('saveRegionConcept', {region, data: _l})
      })
    }
  },
  fetchIdentity({commit}) {
    dpmmService.fetchIdentity().then((r: any) => {
      if (r.status === 200) {
        commit('saveIdentity', r.data)
      }
    }).catch(() => {
      commit('saveIdentity', {})
    })
  },
  async fetchMachinePassword({commit, getters}) {
    const serialNumber = getters.getCurrentSerial
    try {
      const {data} = await dpmmService.fetchMachinePassword(serialNumber)
      commit('saveMachinePassword', data)
    } catch {
      commit('saveMachinePassword', null)
    }
  }
}

export default actions
